var React = require('react');

function SuccessMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.2917 0.839844C5.95088 0.839844 0 6.71138 0 13.9543C0 21.1972 5.95088 27.0687 13.2917 27.0687C20.6325 27.0687 26.5833 21.1972 26.5833 13.9543C26.5833 6.71138 20.6325 0.839844 13.2917 0.839844ZM19.5836 11.2206C20.0555 10.7551 20.0555 10.0002 19.5836 9.53459C19.1117 9.069 18.3466 9.069 17.8747 9.53459L11.4792 15.8449L8.70859 13.1113C8.2367 12.6457 7.47163 12.6457 6.99975 13.1113C6.52786 13.5768 6.52786 14.3317 6.99975 14.7973L10.6247 18.374C11.0966 18.8396 11.8617 18.8396 12.3336 18.374L19.5836 11.2206Z","fill":"#52C41A"}));
}

SuccessMark.defaultProps = {"width":"27","height":"28","viewBox":"0 0 27 28","fill":"none"};

module.exports = SuccessMark;

SuccessMark.default = SuccessMark;
